module.exports = __webpack_public_path__ + "images/a77830192b815b4e1c5ffd7bed8c3ff3.webp";